import { Page } from 'components/common';
import React, { useEffect, useState } from 'react';
import BackButton from 'components/refactoring/BackButton';
import { ApiClient, } from "services";
import { NotificationManager } from 'react-notifications';
import { HoverCard } from "components";
import master_file_icon from "assets/images/folder-files-and-folders-svgrepo-com.svg";
import summary_icon from "assets/images/writing-note-svgrepo-com.svg";
import requirements_icon from "assets/images/requeriments-svgrepo-com.svg";
import assessment_icon from "assets/images/assessment.svg";
import { Col, Nav, Row } from 'reactstrap';

const AuditReportsFiles = ({ t, match }) => {
    const year = match.params.id;
    const client = ApiClient();

    const [filesData, setFilesData] = useState(null)
    useEffect(() => {
        fetchReportsIds();
     }, []);

     const fetchReportsIds = async () => {

        try {
          const master_file_obj = await client.get(`/reports-files/${year}`);
          setFilesData(master_file_obj.data)
          
        } catch (error) {
          NotificationManager.error(error?.response?.data?.error || t("Something went wrong"));
        }
      };

    return (
        <Page title={t("Audit Files")}>
            <BackButton />
            <Row>
              <Nav>
                <Col md={6}>
                  <HoverCard
                    imgSrc={master_file_icon}
                    to={`/reports/audit_reports/master_file/${year}${`/${filesData?.reports?.master_files_id || "new"}`}`}
                    title={t("Master Files")}
                    description={t("Manage your master files, add files, edit file names and more.")}
                  />
                </Col>
                <Col md={6}>
                  <HoverCard
                    imgSrc={requirements_icon}
                    to={`/reports/audit_reports/audit_requirements/${year}/${filesData?.reports?.audit_requirements_id || "new"}`}
                    title={t("Audit Requirements")}
                    description={t("Manage your audit requirements, add accounts.")}
                  />
                </Col>
                <Col md={6}>
                  <HoverCard
                    imgSrc={assessment_icon}
                    to={`/reports/audit_reports/request_during_audit/${year}/${filesData?.reports?.request_during_audit_id || "new"}`}
                    title={t("Request during Audit")}
                    description={t("Manage your request during audit reports")}
                  />
                </Col>
                <Col md={6}>
                  <HoverCard
                    imgSrc={summary_icon}
                    to={`/reports/audit_reports/report_summary/${year}/${filesData?.reports?.report_summary_id || "new"}`}
                    title={t("Report summary")}
                    description={t("Submit your report summary")}
                  />
                </Col>
              </Nav>
            </Row>
        </Page>
    );
};

export default AuditReportsFiles;
